import React from 'react';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';

export function GenericChoiceStep({ 
  question, 
  subtitle, 
  options, 
  value, 
  onChange, 
  onNext, 
  multiSelect = false 
}) {
  const handleSelect = (optionValue) => {
    if (multiSelect) {
      const current = Array.isArray(value) ? value : [];
      const isSelected = current.includes(optionValue);
      const newValue = isSelected 
        ? current.filter(v => v !== optionValue) 
        : [...current, optionValue];
      onChange(newValue);
    } else {
      onChange(optionValue);
      // Immediate feedback and logic check
      setTimeout(() => onNext(optionValue), 350);
    }
  };

  const isSelected = (val) => {
    if (multiSelect) return Array.isArray(value) && value.includes(val);
    return value === val;
  };

  return (
    <div className="w-full space-y-3 md:space-y-8 flex flex-col h-full justify-center py-2">
      <div className="text-center space-y-1 md:space-y-3">
        <h2 className="font-heading text-xl sm:text-2xl md:text-5xl font-bold leading-tight px-2">{question}</h2>
        {subtitle && <p className="text-gray-400 text-[11px] sm:text-sm md:text-lg">{subtitle}</p>}
      </div>

      <div className={`grid gap-2 md:gap-4 px-1 ${
        options.length > 4 
          ? 'grid-cols-2 md:grid-cols-3' 
          : options.length === 3 ? 'grid-cols-1 sm:grid-cols-3' : 'grid-cols-1 sm:grid-cols-2'
      }`}>
        {options.map((opt, idx) => {
          const val = typeof opt === 'string' ? opt : opt.value;
          const label = typeof opt === 'string' ? opt : opt.label;
          const Icon = typeof opt === 'object' && opt.icon ? opt.icon : null;

          return (
            <Card
              key={idx}
              selected={isSelected(val)}
              onClick={() => handleSelect(val)}
              className={`flex flex-col items-center justify-center text-center p-3 md:p-8 min-h-[60px] sm:min-h-[100px] md:min-h-[160px] gap-1.5 md:gap-4`}
            >
              {Icon && (
                <Icon 
                  size={24} 
                  className={`${isSelected(val) ? "text-brand-blue" : "text-gray-500"} md:w-10 md:h-10`} 
                />
              )}
              <span className="text-xs sm:text-sm md:text-xl font-bold leading-tight">{label}</span>
            </Card>
          );
        })}
      </div>

      {multiSelect && (
        <div className="flex justify-center pt-4 md:pt-8">
          <Button 
            onClick={() => onNext()} 
            disabled={!value || value.length === 0}
            className="w-full md:w-auto md:min-w-[240px] h-12 md:h-16 text-sm md:text-lg"
          >
            Continue
          </Button>
        </div>
      )}
    </div>
  );
}